<template>
  <div>
    <el-carousel height="650px">
      <el-carousel-item v-for="(item, index) in list" :key="index">
        <img :src="item.picture" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: { info: Object },
  data() {
    return {
      list: [],
    };
  },
  watch: {
    info: {
      handler(val) {
        this.list = val.wxSchoolPageItemList;
      },
      deep: true,
    },
  },
  mounted() {
    this.list = this.info.wxSchoolPageItemList;
  },
};
</script>
<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/banner/banner1/index.vue